import axios from "axios";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  "https://elaritech-production.up.railway.app"
).replace(/\/$/, "");

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

export default api;
